import React from "react";
import {useFormikContext} from "formik";
import {FlexRow, Button} from "@reside/ui";

import {Space} from "../../../../atoms/space";
import {ButtonLink} from "../../../../atoms/button-link";
import {useUserQuery} from "../../../page-admin-user-edit/hooks/useUserQuery";
import {useUserProfileRouteParams} from "../../route";

export const SubmitButtons = () => {
  const {submitForm, isValid, dirty, isSubmitting} = useFormikContext();
  const {userId} = useUserProfileRouteParams();
  const {data: user} = useUserQuery({userId});
  const isReadOnly = user?.isSsoUser ?? false;

  return (
    <>
      <FlexRow></FlexRow>
      <Space>
        <ButtonLink to="/admin">Cancel</ButtonLink>
        <Button
          testId="saveProfileButton"
          color="success"
          onClick={submitForm}
          disabled={!isValid || !dirty || isSubmitting || isReadOnly}
          type="submit"
        >
          Save
        </Button>
      </Space>
    </>
  );
};
